import React from 'react';
import { Link } from 'react-router-dom';
import HttpManager from '../utils/HttpManager';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'

function Registration() {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const RegisterUser = async () => {
    const newErrors = {};

    if (!firstName.trim()) newErrors.firstName = 'First Name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last Name is required';
    if (!email.trim()) newErrors.email = 'Email is required';
    if (!mobileNumber.trim()) newErrors.mobileNumber = 'Mobile Number is required';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Submit form or perform action
      console.log({ firstName, lastName, email, mobileNumber });

      setLoading(true);

      let registrationModel = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        MobileNumber: mobileNumber
      }
      let registrationResponse = null;
      try {
        registrationResponse = await new HttpManager(navigate).post('/User/Register', registrationModel);

        if (registrationResponse.IsSuccess === true && registrationResponse.Message === "User registration successfully done") {
          localStorage.setItem("Registration", JSON.stringify(registrationModel));
          navigate('/VerifyEmail'); // 👈 Navigate to /register
        }
      }
      catch (error) {
        Swal.fire({
          title: "Registration Failed",
          text: "Registration failed due to technical error, kindly retry after sometime",
          icon: "error"
        });

      }
      finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 w-100">
      <main className="form-signin w-100 m-auto">
        <form>
          <div className="text-center mb-4">
            <img class="mb-4" src="/DecipherX_Logo1.svg" alt="decipherX Logo" width="102" height="87" />
          </div>
          {/* <h1 className="h3 mb-3 fw-normal text-center">User Registration</h1> */}

          <div className="form-floating my-3">
            <input
              type="text"
              className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
              id="txtFirstName"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <label htmlFor="txtFirstName">First Name</label>
            {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
          </div>

          <div className="form-floating my-3">
            <input
              type="text"
              className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
              id="txtLastName"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <label htmlFor="txtLastName">Last Name</label>
            {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
          </div>

          <div className="form-floating my-3">
            <input
              type="email"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              id="txtEmail"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="txtEmail">Email address</label>
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>

          <div className="form-floating my-3">
            <input
              type="text"
              className={`form-control ${errors.mobileNumber ? 'is-invalid' : ''}`}
              id="txtMobileNumber"
              placeholder="+91-XXXXXXXXXX"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
            <label htmlFor="txtMobileNumber">Mobile Number (with country code)</label>
            {errors.mobileNumber && <div className="invalid-feedback">{errors.mobileNumber}</div>}
          </div>

          <button className="btn btn-primary w-100 py-2" type="button" onClick={RegisterUser} disabled={loading}>

            {!loading ? "Sign Up" : (
              <>
                <span className="dot dot1 mx-2 text-center"></span>
                <span className="dot dot2 mx-2"></span>
                <span className="dot dot3 mx-2"></span>
              </>
            )}
          </button>

          <div className="text-end my-3">
            <label className="form-check-label" for="checkDefault">
              Already a member?
            </label>
            <Link to={"/Login"} style={{ "textDecoration": "none" }}> Login</Link>
          </div>

          <p className="mt-5 mb-3 text-body-secondary">decipherX © 2026</p>
        </form>
      </main>
    </div>
  );
}

// async function RegisterUser() {
//   let firstName = document.getElementById('txtFirstName').value;
//   let lastName = document.getElementById('txtLastName').value;
//   let email = document.getElementById('txtEmail').value;
//   let mobileNumber = document.getElementById('txtMobileNumber').value

//   let registrationModel = {
//     FirstName: firstName,
//     LastName: lastName,
//     Email: email,
//     MobileNumber: mobileNumber
//   }

//   let registrationResponse = await HttpManager.post('/User/Register', registrationModel);
// }

export default Registration;